import { IsIn, IsOptional } from 'class-validator';
import {
  DEADLINE_ARCHIVE_REASONS,
  type DeadlineArchiveReason,
} from './deadline-management.constants';

export class ArchiveDeadlineDto {
  /** Assente = archiviazione manuale; `NO_LONGER_NEEDED` = "Chiudi" dello scadenzario consulente. */
  @IsOptional()
  @IsIn(DEADLINE_ARCHIVE_REASONS)
  reason?: DeadlineArchiveReason;
}
